module.exports = __webpack_public_path__ + "img/check-green.dd11aff9.svg";